// extracted by mini-css-extract-plugin
module.exports = {"BooleanListFeature":"wl_a bhv_b"};